import React from 'react';
import { Tabs, Typography } from 'antd';
import {
  LoginOutlined,
  BarChartOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import LoginAnalyticsPage from './LoginAnalyticsPage';
import AnalyticsPage from './AnalyticsPage';

const { Title, Text } = Typography;

export default function MonitoringPage() {
  const { t } = useTranslation();

  return (
    <div style={{ padding: 20 }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={4} style={{ margin: 0 }}>
          🛡️ {t('monitoring.pageTitle', '監控中心')}
        </Title>
        <Text type="secondary">{t('monitoring.pageSubtitle', '後台帳號登入紀錄與前台網站訪客每日數量')}</Text>
      </div>
      <Tabs
        defaultActiveKey="login"
        items={[
          {
            key: 'login',
            label: (
              <span>
                <LoginOutlined style={{ marginRight: 6 }} />
                {t('monitoring.loginTab', '登入紀錄')}
              </span>
            ),
            children: <LoginAnalyticsPage />,
          },
          {
            key: 'visitors',
            label: (
              <span>
                <BarChartOutlined style={{ marginRight: 6 }} />
                {t('monitoring.visitorTab', '前台訪客每日數量')}
              </span>
            ),
            children: <AnalyticsPage />,
          },
        ]}
      />
    </div>
  );
}
